//* Style
import TitleAndTextStyle from './style'

//* Components
import Text from 'components/common/Text'
import Container from 'components/common/Container'

const TitleAndText = ({ title, description, first }) => {
	return (
		<TitleAndTextStyle>
			<Container first={first}>
				<div className='content-wrap'>
					<Text tag={first ? 'h1' : 'p'} className={'h3 font-ping-bolder title'}>
						{title}
					</Text>
					<Text className={'h4 font-ping'}>{description}</Text>
				</div>
			</Container>
		</TitleAndTextStyle>
	)
}

export default TitleAndText
